module.exports = __webpack_public_path__ + "static/img/twitter.1798859.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/twitter.png
// module id = Ednz
// module chunks = 1